module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/dos-and-donts-for-wedding-guests-46d1b04e827e1258a9e9810a23a00a61.jpg";